/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  addonContainer: {
    mb: '3.5rem',
    pr: 0,
    [theme?.breakpoints.down('sm')]: {
      mb: 0,
    },
  },
  addonBox: {
    pl: 0,
    pr: 0,
    display: { sm: 'flex', md: 'flex' },
    flexDirection: { sm: 'column', md: 'column' },
    alignItems: { sm: 'center', md: 'center' },
    justifyContent: { sm: 'center', md: 'center' },
  },
  addOnInfo: {
    paddingBottom: '3rem',
    [theme?.breakpoints.down('sm')]: {
      paddingBottom: '1rem',
    },
  },
  offerSlider: {
    centerSwiper: {
      '& .swiper-wrapper': {
        [theme?.breakpoints?.up('md')]: {
          display: 'flex',
          justifyContent: 'center',
          gap: '1.5%',
        },
      },
    },
    swiper: {
      [theme?.breakpoints.up('sm')]: {
        width: '100%',
      },
      [theme?.breakpoints.up('lg')]: {
        width: '73rem',
        '& .swiper-slide': {
          paddingRight: '0',
        },
      },

      [theme?.breakpoints.between('sm', 'md')]: {
        '& .swiper-pagination': {
          position: 'inherit',
        },
      },
      [theme?.breakpoints.up('md')]: {
        '& .swiper-pagination': {
          position: 'inherit',
        },
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme?.palette?.primary?.buttonColor,
      },
      '& .content-carousel-broadband-tv-offer-card': {
        [theme?.breakpoints.down('sm')]: {
          pb: '0.688rem !important',
        },
      },
      '& .content-carousel-broadband': {
        height: { xs: 'fit-content' },
        [theme?.breakpoints.up('lg')]: {
          pl: 0,
          pr: 0,
        },
        [theme?.breakpoints.down('sm')]: {
          pt: 0,
          pl: 2.25,
          pb: 9,
          pr: 2.25,
        },
        [theme?.breakpoints.up('sm')]: {
          pt: 0,
          pl: 3.75,
          pb: 0,
          pr: 3.75,
        },
        [theme?.breakpoints.between('sm', 'md')]: {
          p: 0,
        },
        [theme?.breakpoints.only('md')]: {
          pt: 2,
          pl: 1.375,
          pb: 4,
          pr: 1.375,
        },
      },
      '& .content-carousel-broadband .swiper-slide': {
        paddingTop: '0rem',
        paddingBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme?.breakpoints.up('lg')]: {
          '& .MuiCardContent-root': {
            p: 0,
          },
          '& .offerBody': {
            p: '2em',
          },
          '& .offer-card-body': {
            p: 0,
            width: '22.5rem',
          },
        },
        [theme?.breakpoints.up('lg')]: {
          '& .offer-card': {
            width: '22.5rem',
            boxSizing: 'border-box',
          },
        },
        [theme?.breakpoints.between('sm', 'md')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme?.breakpoints.up('sm')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme?.breakpoints.down('sm')]: {
          '&.swiper-slide-active': {
            // transform: 'scale(1.1)',
            width: '100% !important',
            '& .offer-card': {
              width: 'inherit',
            },
          },
          '&.swiper-slide-prev': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
          '&.swiper-slide-next': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
        },
      },
    },
  },
});

export default styles;
